/* eslint-disable @typescript-eslint/consistent-type-definitions */
import {uploadStateStore} from '@/stores/UploadStateStore';

type ModalInstance = {confirm: (config: any) => void};

export function withUploadGuard(modal: ModalInstance, action: () => void | Promise<void>): void {
    if (!uploadStateStore.isUploading) {
        action();
        return;
    }
    modal.confirm({
        icon: null,
        title: '文件上传中',
        content: '当前有文件正在上传，切换任务将导致上传失败，确认切换吗？',
        okText: '确认切换',
        cancelText: '取消',
        onOk: async () => {
            uploadStateStore.abortUpload();
            await action();
        }
    });
}
